<template>
  <div class="body-div">
    <div class="top-div">
      <div class="table">
        <table>
          <thead>
            <tr class="text-center">
              <th>ASSIGNED WITHOUT DUPLICATES</th>
              <th class="td-count">TODAY</th>
              <th class="td-count">LAST 30 DAYS</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="assign in paginate(assignReportType[0], pageNum, 26)"
              :key="assign.id"
            >
              <td>{{ assign.user.full_name }}</td>
              <td class="td-count">{{ assign.count_today }}</td>
              <td class="td-count">{{ assign.count_month }}</td>

              <td v-for="cond in assign.campaign_aaid" :key="cond.id">
                <span>{{ cond.id }} | {{ cond.amount }}</span>
              </td>
              <td v-for="cond in assign.country_id" :key="cond.id">
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }}</span
                >
              </td>
              <td v-for="cond in assign.keyword" :key="cond.id">
                <span>{{ cond.id }} | {{ cond.amount }}</span>
              </td>
            </tr>
          </tbody>
        </table>

        <table>
          <thead>
            <tr class="text-center">
              <th>ASSIGNED DUPLICATES</th>
              <th class="td-count">TODAY</th>
              <th class="td-count">LAST 30 DAYS</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="dupAssign in paginate(assignReportType[1], pageNum, 26)"
              :key="dupAssign.id"
            >
              <td>{{ dupAssign.user.full_name }}</td>
              <td class="td-count">{{ dupAssign.count_today }}</td>
              <td class="td-count">{{ dupAssign.count_month }}</td>

              <td v-for="cond in dupAssign.campaign_aaid" :key="cond.id">
                <span>{{ cond.id }} | {{ cond.amount }}</span>
              </td>
              <td v-for="cond in dupAssign.country_id" :key="cond.id">
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }}</span
                >
              </td>
              <td v-for="cond in dupAssign.keyword" :key="cond.id">
                <span>{{ cond.id }} | {{ cond.amount }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="paginationContainer text-center">
          <div class="btn-group ">
            <button
              v-if="pageNum !== 1"
              @click="backPage"
              class="btn btn-sm s-btn-sm page-btn"
              :disabled="pageNum === 1"
            >
              <i class="fa fa-chevron-left"></i>
            </button>
            <span class="btn btn-sm s-btn-sm page-num ">
              {{ pageNum }}
            </span>
            <button
              v-if="paginate(assignReportType[0], pageNum + 1, 26).length !== 0"
              @click="nextPage"
              class="btn btn-sm s-btn-sm page-btn"
              :disabled="
                paginate(assignReportType[0], pageNum + 1, 26).length === 0
              "
            >
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
      <loader
        :size="'8px'"
        v-if="assignReportBusy[0] || assignReportBusy[1]"
      ></loader>

      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>

    <div class="bottom-div" v-if="false">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >
    </div>
    <loader :size="'11px'" v-if="reqReportsBusy"></loader>

    <div class="fab"><span class="fas fa-file-csv"></span></div>
  </div>
</template>

<script>
import Loader from "../../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
export default {
  name: "Assignments",
  components: { Loader },
  data() {
    return {
      reqReportsBusy: false,
      assignReportBusy: {
        0: false,
        1: false
      },
      assignReportType: {
        0: [],
        1: []
      },
      pageNum: 1
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", ["dictionaries"])
  },
  created() {
    this.getAssignmentsByType(0);
    this.getAssignmentsByType(1);
  },
  methods: {
    paginate(arr, page_number, page_size) {
      return arr.slice((page_number - 1) * page_size, page_number * page_size);
    },
    nextPage() {
      this.pageNum = this.pageNum + 1;
    },
    backPage() {
      if (this.pageNum > 1) {
        this.pageNum = this.pageNum - 1;
      }
    },

    getAssignmentsByType(isDuplicate) {
      if (
        !this.assignReportBusy[isDuplicate] &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        this.assignReportBusy[isDuplicate] = true;
        apiClientCreator(`reports/assignments/types/${isDuplicate}`)
          // .get("", { params: this.queryObject })
          .get("")
          .then(res => {
            this.assignReportType[isDuplicate] = res.data;
            this.assignReportType[isDuplicate].sort((a, b) => {
              if (a.count_month > b.count_month) {
                return -1;
              }
              if (a.count_month < b.count_month) {
                return 1;
              }
              return 0;
            });
            this.assignReportBusy[isDuplicate] = false;
          })
          .catch(err => {
            this.assignReportBusy[isDuplicate] = false;
          });
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    }
  }
};
</script>

<style scoped>
.body-div {
  padding: 5px 5px 1px 5px;
}
.top-div {
  width: 100%;
  margin: auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}
.bottom-div {
  width: 100%;
  margin: 5px auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
  height: 650px;
  overflow-y: scroll;
}
.fab {
  background-color: transparent;
  padding: 0;
  font-size: 30px;
  line-height: 30px;
  color: green;
  text-align: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 20%;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.fab:hover {
  box-shadow: 0 5px 11px 0 #666;
  transform: scale(1.05);
}
.table {
  /* float: left;*/
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-bottom: 10px;
}
.table table {
  font-size: 12px;
  /*   margin-right: auto;*/
  margin: 15px 7px;
}
.table thead {
  border-bottom: solid 2px #eff3f6;
}
.table th {
  text-align: left;
  font-size: 12px;
}
.table .td-count {
  text-align: center;
}
.table td {
  border-bottom: solid 2px #eff3f6;
}
.text-center {
  font-weight: bold;
}

.paginationContainer {
  /*margin-left: 10px;*/
  font-size: 15px;
  width: 110px;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.page-btn {
  background: white;
}

.page-num {
  cursor: inherit;
}

/*.table table {
  font-size: 13px;
  width: 200px;
  margin-right: auto;
  margin-left: auto;

}
.table tbody{
  display: block;
  height: 332px;
  overflow: auto;
  width: 100%

}
.table thead tr {
  border-bottom: solid 2px #eff3f6;
  position: relative;

}*/
</style>
